import { useContext, useEffect, useState } from "react";
import {
  Flex,
  Text,
  Center,
  Link,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import Image from "next/image";
import { getReferenceParams } from "app-head";

import { IIndexable } from "types/common";
import { EXPLORE_STAKING } from "constants/analytics";

import {
  Hedera,
  Fantom,
  Terra_2_0,
  Near,
  Binance,
} from "assets/svg/blockchains_dark";
import {
  Hedera_light,
  Fantom_light,
  Terra_2_0_light,
  Near_light,
  Binance_light,
} from "assets/svg/blockchains_light";
import chevron_right_light from "assets/svg/chevron_right_light.svg";
import chevron_right_dark from "assets/svg/chevron_right_dark.svg";

// Contexts
import { StakeContext } from "providers/StakeProvider";
import useLedgerApp from "hooks/useLedgerApp";
import { useRouter } from "next/router";

type StakingOptionsProps = {
  key: string;
  title: string;
  link: string;
};

type NearSideBarLiquidStakingProps = {
  stakingOptionsData: StakingOptionsProps[];
};

const BLOCKCHAINS_ICONS: IIndexable = {
  light: {
    hedera: Hedera_light,
    near: Near_light,
    bnb: Binance_light,
    fantom: Fantom_light,
    terra: Terra_2_0_light,
  },
  dark: {
    hedera: Hedera,
    near: Near,
    bnb: Binance,
    fantom: Fantom,
    terra: Terra_2_0,
  },
};

const LiquidStaking = ({
  stakingOptionsData,
}: NearSideBarLiquidStakingProps) => {
  const { track, config } = useContext(StakeContext);
  const router = useRouter();
  const [utmParams, setUTMParams] = useState<string>("");

  useEffect(() => {
    const searchStr = decodeURIComponent(window.location.search);
    const xQuery: any = new URLSearchParams(searchStr);
    const query: any = {};

    for (const [key, value] of xQuery.entries()) {
      query[key] = value;
    }
    const refParams = getReferenceParams();
    const x: any = {};

    for (let key in refParams) {
      if (query[key]) {
        x[key] = query[key];
      }
    }
    const search = new URLSearchParams(x).toString();
    setUTMParams(search === "" ? "" : `/?${search}`);
  }, [router]);

  const { colorMode } = useColorMode();

  const { isLedgerApp } = useLedgerApp(config);

  const rightArrowIcon = useColorModeValue(
    chevron_right_light,
    chevron_right_dark
  );

  if (isLedgerApp) return null;

  return (
    <>
      <Text fontSize="10px" color="brand.textInactive" fontFamily="bold">
        EXPLORE LIQUID STAKING
      </Text>
      {stakingOptionsData.map((chain) => (
        <Link
          cursor="pointer"
          href={`${chain.link}${utmParams}`}
          p="0 0.5rem"
          key={chain.key}
          h="24px"
          w="176px"
          mt="20px"
          lineHeight="0px"
          onClick={() =>
            track(EXPLORE_STAKING, {
              next_blockchain: chain.key,
            })
          }
        >
          <Flex alignItems="center" justifyContent="space-between">
            <Flex alignItems="center">
              <Center
                h="24px"
                w="24px"
                borderRadius="50%"
                bg="brand.backgroundLight"
              >
                <Image
                  src={BLOCKCHAINS_ICONS[colorMode][chain.key]}
                  width={14}
                  height={14}
                  alt={chain.key}
                />
              </Center>
              <Text
                ml="0.5rem"
                fontWeight="500"
                fontSize="12px"
                color="brand.textColor"
                _hover={{
                  color: "brand.textInactive",
                }}
              >
                {chain.title}
              </Text>
            </Flex>
            <Image src={rightArrowIcon} width={24} height={24} alt="line" />
          </Flex>
        </Link>
      ))}
    </>
  );
};

export default LiquidStaking;
